var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('category-selection-tree',{attrs:{"categories-marked-as-included":_vm.includedCategoryIds,"is-virtual":_vm.isVirtual,"set-max-height":false,"compact":"","start-expanded":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }